import { isValidDateString } from '@/common/utils/dateValidator'
import { z } from 'zod'

export const createGovernmentAllocationSchema = z.object({
  branch_id: z.object(
    {
      label: z.string(),
      value: z.string(),
    },
    { message: 'Campo Filial é obrigatório' },
  ),
  start_of_document_validity: z
    .string({ message: 'Campo Início é obrigatório' })
    .regex(/^\d{2}\/\d{2}\/\d{4}$/, { message: 'Use o formato dd/mm/aaaa' })
    .refine(isValidDateString, { message: 'Data inválida' }),
  end_of_document_validity: z
    .string({ message: 'Campo Fim é obrigatório' })
    .regex(/^\d{2}\/\d{2}\/\d{4}$/, { message: 'Use o formato dd/mm/aaaa' })
    .refine(isValidDateString, { message: 'Data inválida' }),
  office_number: z.string({ message: 'Campo Número do ofício é obrigatório' }).min(1, {
    message: 'Campo Número do ofício é obrigatório',
  }),
  total_value: z.string({ message: 'Campo Valor total é obrigatório' }).min(1, {
    message: 'Campo Valor total é obrigatório',
  }),
  file: z.custom<File>().refine((file) => file, 'Anexo é obrigatório'),
})

export type CreateGovernmentAllocationValidationSchema = z.infer<typeof createGovernmentAllocationSchema>
